import {Directive, Input} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {isNullOrUndefined} from 'util';

@Directive({
    selector: 'tfl-filter-field-input, tfl-filter-field-date-range-picker, tfl-filter-field-select, tfl-filter-field-amount-range'
})
export class FilterFieldClearDirective {

    @Input('formGroup') formGroup: FormGroup;
    @Input('controlName') controlName: string;
    @Input('defValue') defValue;

    public reset() {
        // controls[], not formGroup[name]: a control named like a FormGroup property (e.g. 'status') broke the reset
        let control: AbstractControl = this.formGroup && this.formGroup.controls[this.controlName];
        if (!isNullOrUndefined((control))) control.reset(this.defValue);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-field-clear.directive.ts